import React, { useState, useEffect } from 'react'
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { connect } from 'react-redux';
import { getImpayesByUser } from '../flux/actions/encaissementActions';
import { IAuthReduxProps } from '../types/interfaces';
import EncaissementListTable from './encaissement_list/EncaissementListTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { constants } from '../types/constants';
import { capitalizeText } from '../services/formatting';

const UnpaidChecksPopup = ({
  auth
 }: IAuthReduxProps) => {
  const OWN_TAB_NAME = "OWN"
  const [activeTab, setActiveTab] = useState(OWN_TAB_NAME);
  const [ownImpayes, setOwnImpayes] = useState<any[]>([])
  const [bvImpayes, setBvImpayes] = useState<any[]>([])
  const [filteredRows, setFilteredRows] = useState<any[]>([])
  const [encLoading, setEncLoading] = useState(false)
  const [minimized, setMinimized] = useState(false)
  
  useEffect(() => {
    if(auth?.user?.id){
      setEncLoading(true)
      getImpayesByUser(auth.user.id).then(e => {
        setOwnImpayes(e?.ownImpayes || [])
        setBvImpayes(e?.bvImpayes || [])
      }).finally(() => setEncLoading(false))
    }
    else{
      setOwnImpayes([])
      setBvImpayes([])
    }
  }, [auth?.user])

  if(!ownImpayes?.length && auth?.user?.speciality !== constants.ROLE_RESPONSABLE) return null
  if(!ownImpayes?.length && !bvImpayes?.length && auth?.user?.speciality === constants.ROLE_RESPONSABLE) return null

  const OwnImpayesComp = () => <EncaissementListTable encaissementsData={ownImpayes} showProjectColumn showStatutColumn impayePopup />
  const BvImpayesComp = ({impayes}) => <EncaissementListTable encaissementsData={impayes} showProjectColumn={false} showStatutColumn impayePopup />

  return (
    <div className="impayeWarningContainer" style={!minimized ? {opacity: 1} : {}}>
      {/* Header */}
      <div className="impayeWarningDiv" onClick={() => setMinimized(!minimized)}>
        <span className="impayeWarningTitle"><FontAwesomeIcon icon={faExclamationTriangle} style={{paddingRight: 5}} />{minimized ? `${ownImpayes.length} Impayé${ownImpayes.length > 1 ? "s" : ""}` : <>Mes Chèques Impayés: {ownImpayes.length}{auth?.user?.speciality === constants.ROLE_RESPONSABLE && ` — Bureau de vente: ${bvImpayes.reduce((e, t) => e + (t.impayes || []).length, 0)}`}</>}</span>
        <span className="impayeWarningCaret">▾</span>
      </div>

      {/* Content */}
      {!minimized && (
        <div style={{ padding: '12px 14px', maxHeight: '70vh', overflowY: 'auto' }}>
          {auth?.user?.speciality === constants.ROLE_RESPONSABLE ? <>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={`fullFlexCenter${activeTab === OWN_TAB_NAME ? " active" : ""}`}
                  onClick={() => setActiveTab(OWN_TAB_NAME)} >
                  Mes Impayés ({ownImpayes.length})
                </NavLink>
              </NavItem>
              {bvImpayes.map(e => ({id: `PROJECT_${e.project?.id}`, label: `Bureau ${capitalizeText(e.project?.LIBELE || "-")}`, count: e.impayes?.length || 0})).map((e, key) => <NavItem key={key}>
                <NavLink
                  className={`fullFlexCenter${activeTab === e.id ? " active" : ""}`}
                  onClick={() => setActiveTab(e.id)} >
                  {e.label}{e.count || e.count === 0 ? ` (${e.count})` : ""}
                </NavLink>
              </NavItem>)}
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={OWN_TAB_NAME}>
                <OwnImpayesComp />
              </TabPane>
              {bvImpayes.map((e, key) => <TabPane tabId={`PROJECT_${e.project?.id}`} key={key}>
                <BvImpayesComp impayes={e.impayes || []} />
              </TabPane>)}
            </TabContent>
          </> : <OwnImpayesComp />}
        </div>
      )}
    </div>
  )
}

// export default UnpaidChecksPopup

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, {})(UnpaidChecksPopup);